/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_SCHEDULED_USER_LIST = gql`
  query GetUsersWithBoxes(
    $filters: UserAndBoxAggFilterInput
    $options: GetManyOptions
  ) {
    getUsersWithBoxes(filters: $filters, options: $options) {
      count
      limit
      skip
      content {
        _box {
          masqID
          collectorProfile {
            name
            collectorType
          }
          schedule {
            band {
              name
            }
            distCent {
              name
            }
            isPublished
            eventEndTime
            eventStartTime
            vipOnly
            name
            scheduleID
            sectionOptTypes
            sections
            attendeesCount
          }
        }
        email
        firstName
        fullName
        lastName
        image
        phoneNumbers {
          number
          type
        }
        primaryContactNo
      }
    }
  }
`;
